module.exports = __webpack_public_path__ + "img/111-afghanistan.fd81c9e1.svg";